// 商品订单列表
export default {
    heard_title: "Item Order List",
    btn_createOrder: "Create order",
    btn_close: "Close",
    btn_refund: "Refund",
    btn_print: "Print receipt",
    // 关闭弹出框
    dt_closeOrder: "Close order",
    dp_memo: "remark",
    // 提示相关
    confirm_refund:
        "This operation will be refunded directly to the account, do you want to continue?",
    sm_refund: "Refund submitted successfully",
    em_refund: "Failed to submit refund",
    im_refund: "Refund cancelled",
    sm_print: "Print successful",
    em_print: "Print failed"
};
